export const UNKNOWN_AUTHORIZATION_DATE = Symbol("UNKNOWN_AUTHORIZATION_DATE");

const INTEGRATION_STORAGE_KEY_PREFIX = "constantcontact_";

export const INTEGRATION_SYNC_ALL_KEY = `${INTEGRATION_STORAGE_KEY_PREFIX}sync_all`;
export const INTEGRATION_SYNC_NEW_KEY = `${INTEGRATION_STORAGE_KEY_PREFIX}sync_new`;

export const REFETCH_INTERVAL_MS = 3000;

export const TOKEN_QUERY_PARAM = "code";
